import _findLastIndex from 'lodash/findLastIndex';

import { MenuItem } from '../core/api/menu/menu.types';
import { NutritionInfoDataDictionary } from '../core/state/menu/menu.types';
import { QuantityControlType } from '../core/types/basket.types';
import { MenuActionsType } from '../core/types/menu.types';
import { Item as BasketItem } from '../weborder/BasketControl';
import { getStoreInstance } from '../weborder/Store';
import { Utilities } from '../weborder/Utilities';

export const getViewportTopOffset = (isMobile = false): number => {
  const getViewportTopOffsetFromStore = (): number => {
    const store = getStoreInstance();

    if (!store) {
      return 0;
    }

    const state = store.getState();

    const { flipdish } = state;
    const appConfig = flipdish?.AppConfig;

    if (appConfig && appConfig.status === 'success') {
      return appConfig.data.ViewportTopOffset;
    }

    return 0;
  };

  const viewportTopOffset = getViewportTopOffsetFromStore();

  if (!isMobile) {
    return viewportTopOffset;
  }

  const fullScreenOnMobile =
    (Utilities.extraOption &&
      Utilities.extraOption('data-full-screen-on-mobile')) ||
    false;
  const isfullScreenOnMobile = fullScreenOnMobile !== 'false';
  return (!isfullScreenOnMobile && viewportTopOffset) || 0;
};

export const handleScrollToSection = (
  targetId: string,
  isMobile: boolean,
  partialOffset = 0,
): void => {
  const viewportTopOffset: number = getViewportTopOffset(isMobile);
  const targetSection = document.getElementById(targetId);

  const yOffset =
    targetSection.getBoundingClientRect().top +
    window.pageYOffset -
    partialOffset -
    viewportTopOffset;

  window.scrollTo({
    behavior: 'smooth',
    top: yOffset,
  });
};

// TODO - ORD-1259 remove this function when useBasket is rolled out to Menu and Checkout pages
export const handleAddItem = (
  addItem: QuantityControlType['onAddItem'],
  basketItems: BasketItem[],
  item: MenuItem,
  quantity: number,
  onClickItem?: MenuActionsType['onItemClick'],
): void => {
  const handleIncrementSimpleItem = (): void =>
    addItem({
      Count: 1,
      Item: item,
      Options: [],
    });

  const handleIncrementComplexItem = (): void => {
    const [lastItemAdded] = basketItems
      .filter((basketItem) => basketItem?.Item?.MenuItemId === item.MenuItemId)
      .slice(-1);

    addItem({
      Item: lastItemAdded.Item,
      Options: lastItemAdded.Options,
    });
  };

  const hasItemOptions = item.MenuItemOptionSets.length > 0;
  if (!hasItemOptions) {
    return handleIncrementSimpleItem();
  }

  const isIncrementingItem = quantity > 0;
  if (isIncrementingItem) {
    return handleIncrementComplexItem();
  }

  if (onClickItem) {
    return onClickItem({ menuId: item.MenuId, item });
  }

  return handleIncrementSimpleItem();
};

// TODO - ORD-1259 remove this function when useBasket is rolled out to Menu and Checkout pages
export const handleRemoveItem = (
  basketItems: BasketItem[],
  item: MenuItem,
  removeItem: QuantityControlType['onRemoveItem'],
): void => {
  const lastItemIndex = _findLastIndex(
    basketItems,
    (basketItem) => basketItem.Item.MenuItemId === item.MenuItemId,
  );

  removeItem({
    index: lastItemIndex,
    indexName: item.Name,
    menuId: item.MenuId,
  });
};

export const checkMenuItemHasAllergens = (
  nutritionInfo: NutritionInfoDataDictionary,
  publicId: string,
): boolean => !!nutritionInfo?.menuItems[publicId]?.Labels.length;
